import { ContactsOperation } from '~/hooks/toast/eventHandlers/contactsToastEventHandler'
import {
  FaxOperation,
  FaxOperationContext,
} from '~/hooks/toast/eventHandlers/faxToastEventHandler'
import { GeneralOperation } from '~/hooks/toast/eventHandlers/generalToastEventHandler'
import {
  VoicemailOperation,
  VoicemailOperationContext,
} from '~/hooks/toast/eventHandlers/voicemailToastEventHandler'
import {
  WebphoneOperation,
  WebphoneOperationContext,
} from '~/hooks/toast/eventHandlers/webphoneToastEventHandler'

export enum NotificationEmitterEventType {
  PROCESS_UPDATED = 'PROCESS_UPDATED',
}

export enum NotificationDisposition {
  Success = 'green.solid',
  Error = 'red.solid',
  Loading = 'loading',
  Info = 'info',
  Warning = 'warning',
}

export enum NotificationDomain {
  GENERAL = 'GENERAL',
  FAX = 'FAX',
  CONTACTS = 'CONTACTS',
  WEBPHONE = 'WEBPHONE',
  VOICEMAIL = 'VOICEMAIL',
}

export type NotificationDomainOperation =
  | GeneralOperation
  | FaxOperation
  | ContactsOperation
  | WebphoneOperation
  | VoicemailOperation

export type NotificationOperationFromDomain = {
  [NotificationDomain.GENERAL]: GeneralOperation
  [NotificationDomain.FAX]: FaxOperation
  [NotificationDomain.CONTACTS]: ContactsOperation
  [NotificationDomain.WEBPHONE]: WebphoneOperation
  [NotificationDomain.VOICEMAIL]: VoicemailOperation
}

export type DomainOperationContext = {
  [NotificationDomain.GENERAL]: GeneralOperation
  [NotificationDomain.FAX]: FaxOperationContext[FaxOperation]
  [NotificationDomain.CONTACTS]: ContactsOperation
  [NotificationDomain.WEBPHONE]: WebphoneOperationContext[WebphoneOperation]
  [NotificationDomain.VOICEMAIL]: VoicemailOperationContext[VoicemailOperation]
}

export interface NotificationPayload<TDomain extends NotificationDomain> {
  domain: TDomain
  disposition: NotificationDisposition
  message?: string
  operation?: NotificationOperationFromDomain[TDomain]
  context?: DomainOperationContext[TDomain]
}

export type NotificationEmitterPayloadMap<TDomain extends NotificationDomain> =
  {
    [NotificationEmitterEventType.PROCESS_UPDATED]: NotificationPayload<TDomain>
  }
